import { useState, useMemo } from 'react'
import { useInfiniteQuery } from 'react-query'
import { SortByType, SortingType } from '@components/Table/interface'
import { useClient } from '@hooks/useClient'
import { SpenderSectionProps, WithSpenderSectionProps } from './interface'

export function withSpenderSection(Component: React.FC<SpenderSectionProps>) {
  function WithSpenderSection({ searchParams }: WithSpenderSectionProps) {
    const client = useClient()
    const [sortBy, setSortBy] = useState<SortByType>({
      key: '',
      order: SortingType.ASC,
    })

    const {
      data: donationBySpender,
      isFetchingNextPage,
      fetchNextPage,
      isLoading,
    } = useInfiniteQuery(
      ['character-donation-by-spender', searchParams, sortBy],
      ({ pageParam = 1 }) =>
        client!.characterClient.getCharacterDonationBySpender({
          ...searchParams,
          ...sortBy,
          page: pageParam,
          limitPerPage: 10,
        }),
      {
        getNextPageParam: lastPage => {
          if (lastPage && lastPage.data.length) return lastPage.page + 1

          return undefined
        },
      }
    )

    function handleFetchNextPage() {
      if (!isFetchingNextPage) fetchNextPage()
    }

    function handleSort({ key, order }: SortByType) {
      setSortBy(prev => ({ ...prev, key, order }))
    }

    const data = useMemo(
      () => donationBySpender?.pages?.flatMap(page => page.data) ?? [],
      [donationBySpender]
    )

    const componentProps = {
      data,
      handleSort,
      handleFetchNextPage,
      isLoading,
    }

    return <Component {...componentProps} />
  }

  return WithSpenderSection
}
